(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observador = null;

  function vigilar(el) {
    if (!el || el.dataset.mtObs) return;
    el.dataset.mtObs = '1';
    if (reducido || !('IntersectionObserver' in window)) { el.classList.add('mt-visible'); return; }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); observador.unobserve(e.target); }
        });
      }, { threshold: 0.15 });
    }
    observador.observe(el);
  }

  function initReveals(raiz) {
    raiz.querySelectorAll('.mt-reveal, .mt-hero__marco, .mt-tabla').forEach(vigilar);
  }

  // #31 Frase que se ilumina palabra a palabra (el Liquid ya trae los <span>)
  function initFrases(raiz) {
    raiz.querySelectorAll('[data-mt-frase]').forEach(function (bloque) {
      if (bloque.dataset.mtInit) return;
      bloque.dataset.mtInit = '1';
      var palabras = bloque.querySelectorAll('.mt-palabra');
      if (reducido) { palabras.forEach(function (p) { p.classList.add('mt-on'); }); return; }
      function pintar() {
        var r = bloque.getBoundingClientRect();
        var alto = window.innerHeight;
        var progreso = (alto * 0.85 - r.top) / (r.height + alto * 0.35);
        progreso = Math.max(0, Math.min(1, progreso));
        var n = Math.round(progreso * palabras.length);
        palabras.forEach(function (p, i) { p.classList.toggle('mt-on', i < n); });
      }
      window.addEventListener('scroll', pintar, { passive: true });
      window.addEventListener('resize', pintar);
      pintar();
    });
  }

  // #17 Hotspots
  function initHotspots(raiz) {
    raiz.querySelectorAll('[data-mt-hot]').forEach(function (bloque) {
      if (bloque.dataset.mtInit) return;
      bloque.dataset.mtInit = '1';
      var puntos = bloque.querySelectorAll('[data-mt-punto]');
      var items = bloque.querySelectorAll('[data-mt-item]');
      function activar(i) {
        puntos.forEach(function (p) { p.classList.toggle('mt-activo', p.dataset.mtPunto === i); });
        items.forEach(function (it) { it.classList.toggle('mt-activo', it.dataset.mtItem === i); });
      }
      puntos.forEach(function (p) {
        p.addEventListener('mouseenter', function () { activar(p.dataset.mtPunto); });
        p.addEventListener('click', function () { activar(p.dataset.mtPunto); });
      });
      items.forEach(function (it) {
        it.addEventListener('mouseenter', function () { activar(it.dataset.mtItem); });
        it.addEventListener('click', function () { activar(it.dataset.mtItem); });
      });
      if (puntos.length) activar(puntos[0].dataset.mtPunto);
    });
  }

  // #80 FAQ
  function initFaq(raiz) {
    raiz.querySelectorAll('.mt-faq__q').forEach(function (btn) {
      if (btn.dataset.mtInit) return;
      btn.dataset.mtInit = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.mt-faq__item');
        var abierto = item.classList.toggle('mt-abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  // Página de producto: galería + variantes
  function initProducto(raiz) {
    raiz.querySelectorAll('[data-mt-pdp]').forEach(function (pdp) {
      if (pdp.dataset.mtInit) return;
      pdp.dataset.mtInit = '1';
      var slides = pdp.querySelectorAll('[data-mt-slide]');
      var minis = pdp.querySelectorAll('[data-mt-mini]');
      // Muestra una foto o video de la galería; el video arranca sin sonido y se pausa al salir
      function mostrar(id) {
        var hay = false;
        slides.forEach(function (s) { if (s.dataset.mtSlide === String(id)) hay = true; });
        if (!hay) return;
        slides.forEach(function (s) {
          var activo = s.dataset.mtSlide === String(id);
          s.hidden = !activo;
          var video = s.querySelector('video');
          if (video) {
            if (activo) { video.muted = true; var p = video.play(); if (p && p.catch) p.catch(function () {}); }
            else video.pause();
          }
        });
        minis.forEach(function (x) { x.classList.toggle('mt-activo', x.dataset.mtMini === String(id)); });
      }
      minis.forEach(function (m) {
        m.addEventListener('click', function () { mostrar(m.dataset.mtMini); });
      });

      var datos = pdp.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var entrada = pdp.querySelector('input[name="id"]');
      var precio = pdp.querySelector('[data-mt-precio]');
      var tachado = pdp.querySelector('[data-mt-tachado]');
      var boton = pdp.querySelector('[data-mt-boton]');
      var textoBoton = boton ? boton.dataset.mtTexto : '';
      var textoAgotado = boton ? boton.dataset.mtAgotado : '';
      var formato = pdp.dataset.mtMoneda || '{{amount}}';

      function dinero(centimos) {
        var v = (centimos / 100).toFixed(2);
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
                      .replace(/\{\{\s*amount\s*\}\}/, v)
                      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(centimos / 100));
      }

      function actualizar() {
        var elegidas = [];
        pdp.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
          var marcado = grupo.querySelector('input:checked');
          elegidas.push(marcado ? marcado.value : null);
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        });
        if (!v) { if (boton) { boton.disabled = true; boton.textContent = textoAgotado; } return; }
        entrada.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (tachado) {
          if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = dinero(v.compare_at_price); tachado.hidden = false; }
          else { tachado.hidden = true; }
        }
        if (boton) { boton.disabled = !v.available; boton.textContent = v.available ? textoBoton : textoAgotado; }
        if (v.featured_media) mostrar(v.featured_media.id);
      }
      pdp.querySelectorAll('[data-mt-opcion] input').forEach(function (i) { i.addEventListener('change', actualizar); });
    });
  }

  function initTodo(e) {
    var raiz = (e && e.target && e.target.querySelectorAll) ? e.target : document;
    initReveals(raiz);
    initFrases(raiz);
    initHotspots(raiz);
    initFaq(raiz);
    initProducto(raiz);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
